import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";

const DownloadSection = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("DownloadSection", "product_lib/product_download_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.DownloadSection || { Main: {} };

  return (
    <div className="container-xxl py-5">
      <div className="container py-5 px-lg-5">
        <div className="row g-5 align-items-center">
          {/* 左側圖片區塊 */}
          <div className="col-lg-6">
            <img
              className="img-fluid wow fadeInUp"
              data-wow-delay="0.1s"
              src="img/download.png"
              alt="Download App"
            />
          </div>

          {/* 右側下載內容 */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            <h5 className="text-primary fw-medium">{LANGUAGE.Main.Content1}</h5>
            <h1 className="mb-4">{LANGUAGE.Main.Content2}</h1>
            <p className="mb-4">{LANGUAGE.Main.Content3}</p>

            <div className="row g-4">
              {/* Microsoft 下載按鈕 */}
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.7s">
                <a href="/download_windows" className="d-flex bg-primary rounded py-3 px-4">
                  <i className="fab fa-windows fa-3x text-white flex-shrink-0"></i>
                  <div className="ms-3">
                    <p className="text-white mb-0">{LANGUAGE.Main.DownloadBtn}</p>
                    <h5 className="text-white mb-0">{LANGUAGE.Main.Windows}</h5>
                  </div>
                </a>
              </div>

              {/* Mac 下載按鈕 */}
              {/* <div className="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                <a href="/download_mac" className="d-flex bg-primary rounded py-3 px-4">
                  <i className="fab fa-apple fa-3x text-white flex-shrink-0"></i>
                  <div className="ms-3">
                    <p className="text-white mb-0">{LANGUAGE.Main.DownloadBtn}</p>
                    <h5 className="text-white mb-0">{LANGUAGE.Main.Mac}</h5>
                  </div>
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadSection;
